import { asMultiStyleConfig } from '../../utils/theme';
import { getColor } from '../../theme-tools';
var parts = ['container', 'groupTitle', 'item', 'itemEmpty'];
var baseStyle = props => {
  var {
    theme
  } = props;
  return {
    container: {
      border: "1px solid  ".concat(getColor(theme, 'grey.300')),
      borderTop: "2px solid ".concat(getColor(theme, 'grey.400')),
      borderBottom: "2px solid ".concat(getColor(theme, 'grey.400')),
      listStyle: 'none',
      bg: 'white',
      position: 'relative',
      transition: 'box-shadow 0.2s',
      _focusVisible: {
        boxShadow: "0 0 3px 2px ".concat(getColor(theme, 'blue.300')),
        outline: "1px solid ".concat(getColor(theme, 'blue.400'))
      }
    },
    groupTitle: {
      backgroundColor: 'white',
      lineHeight: 'base',
      fontWeight: 'bold',
      fontSize: 'md',
      letterSpacing: 'tight',
      padding: '12px 16px',
      color: 'black',
      borderBottom: "1px solid ".concat(getColor(theme, 'grey.300')),
      listStyle: 'none'
    },
    item: {
      fontSize: 'md',
      lineHeight: 'base',
      letterSpacing: 'tight',
      padding: '10px 16px',
      backgroundColor: 'grey.100',
      borderBottom: "1px solid ".concat(getColor(theme, 'grey.300')),
      cursor: 'pointer',
      _hover: {
        bg: 'blue.1140'
      },
      _focus: {
        bg: 'blue.1140'
      },
      _active: {
        bg: 'blue.1140'
      }
    },
    itemEmpty: {
      fontSize: 'md',
      py: 3,
      px: 5,
      borderBottom: "1px solid  ".concat(getColor(theme, 'grey.300')),
      backgroundColor: 'grey.100'
    }
  };
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});